/* istanbul ignore file */

export const DISAPPOINTED = "disappointed";
export const FLUSHED = "flushed";
export const UNAMUSED = "unamused";
export const DOH = "doh";
